import { render, staticRenderFns } from "./ModalBillPayments.vue?vue&type=template&id=ca899782&scoped=true"
import script from "./ModalBillPayments.vue?vue&type=script&lang=js"
export * from "./ModalBillPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca899782",
  null
  
)

export default component.exports